import acInterceptor from '../acInterceptor';
import { useRequest } from 'alova';

import { SimulatedDebtResponse, SimulatedDebtRequest } from './types';
import { transformPayload } from './transformPayload';
import { getSessionID } from 'redline-client-sdk';

const headers = {
  'Content-Type': 'application/json;charset=UTF-8',
};

const useApiSimulatedDebt = () => {
  const requestHandler = (payload: SimulatedDebtRequest) => {
    // temp format
    const headersBeforeRequest = {
      'Session-ID': getSessionID(),
    };

    const params = payload?.sortField && payload?.sortType ? `?sortField=${payload.sortField}&sortType=${payload.sortType}` : '';
    const usedPath = `/api/divida/buscar${params}`;
    const fmtPayload = transformPayload(payload);

    return acInterceptor({
      baseURL: payload.msUrl,
      headersBeforeRequest
    }).Post<SimulatedDebtResponse>(usedPath, fmtPayload, {
      headers: headers,
    });
  };

  const apiSimulatedDebt = useRequest(requestHandler, {
    immediate: false,
    retry: 5,
  });

  return { apiSimulatedDebt };
};

export default useApiSimulatedDebt;
